import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';

@Injectable({
  providedIn: 'root',
})
export class ClientHttpService extends BaseHttpService {
  private baseURL = `clients`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getServiceInfos(clientId: number) {
    let path = this.routerService.mount(`${this.baseURL}/${clientId}/services`);
    return this.read(path);
  }



}
